var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup6120(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 46,
    fill: "#007BFF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1469 52.6475L46.1771 45.6777L39.2073 52.6475",
    stroke: "#007BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1765 45.6777V61.3598",
    stroke: "#007BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7954 56.812C62.4949 55.8855 63.8375 54.4194 64.6112 52.6452C65.3849 50.8709 65.5457 48.8895 65.0683 47.0137C64.5908 45.1379 63.5023 43.4745 61.9745 42.286C60.4467 41.0975 58.5666 40.4517 56.631 40.4504H54.4355C53.9081 38.4104 52.9251 36.5166 51.5603 34.9112C50.1956 33.3058 48.4847 32.0306 46.5563 31.1816C44.6278 30.3326 42.532 29.9319 40.4264 30.0095C38.3207 30.087 36.2601 30.6409 34.3993 31.6296C32.5386 32.6182 30.9262 34.0157 29.6833 35.7172C28.4404 37.4187 27.5994 39.3798 27.2236 41.453C26.8477 43.5263 26.9467 45.6578 27.5132 47.6873C28.0797 49.7168 29.0989 51.5914 30.4942 53.1703",
    stroke: "#007BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1469 52.6475L46.1771 45.6777L39.2073 52.6475",
    stroke: "#007BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6120);
export default __webpack_public_path__ + "static/media/Group6120.ff5c131ce3302acb6059f7e0ac4e0b8b.svg";
export { ForwardRef as ReactComponent };